import isChirpInURL from './isChirpInURL';

/**
 * Check if CHIRP endpoints should be used.
 * Handles both authenticated and public contexts.
 *
 * Priority:
 * 1. Try isUngatedToCHIRPEndpoints() for authenticated apps (documents-ui)
 * 2. Fall back to isChirpInURL() for public apps (documents-public-ui)
 */
export const isChirpEnabled = () => {
  try {
    // TODO: use quartz getGates() when documents-lib is quartz exlusive
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const gates = require('documents-preview-ui/utils/gates');
    if (gates !== null && gates !== void 0 && gates.isUngatedToCHIRPEndpoints && typeof gates.isUngatedToCHIRPEndpoints === 'function') {
      return gates.isUngatedToCHIRPEndpoints();
    }
  } catch (e) {
    // Module not available in public context
  }
  // Fall back to URL check for public app
  return isChirpInURL() === true;
};